// extracted by mini-css-extract-plugin
export var card = "_m9-0";
export var content = "_m9-2";
export var details = "_m9-3";
export var icon = "_m9-1";
export var iconBlue = "_m9-5";
export var iconBrand = "_m9-4";
export var iconGrayBlue = "_m9-6";
export var iconGreen = "_m9-7";
export var iconIndigo = "_m9-8";
export var iconOrange = "_m9-9";
export var iconPurple = "_m9-a";
export var iconRed = "_m9-b";
export var iconWarning = "_m9-c";